import { render, staticRenderFns } from "./BrandsSelectorModal.vue?vue&type=template&id=ee62889c&scoped=true"
import script from "./BrandsSelectorModal.vue?vue&type=script&lang=js"
export * from "./BrandsSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./BrandsSelectorModal.vue?vue&type=style&index=0&id=ee62889c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee62889c",
  null
  
)

export default component.exports